import { Stack } from "@mui/material";
import { ReactNode } from "react";
import { WHITE } from "@/config/mui/colorPalette";
import theme from "@/config/mui/theme";

type ExpandableCardContentProps = {
  content: (isFocused: boolean) => ReactNode;
  button: (isFocused: boolean) => ReactNode;
  regularHeight: number;
  collapsedHeight: number;
  isFocused: boolean;
  isMobile: boolean;
};

type MobileExpandableCardContentProps = {
  button: (isFocused: boolean) => ReactNode;
  content: (isFocused: boolean) => ReactNode;
  isFocused: boolean;
};

type DesktopExpandableCardContentProps = Omit<
  ExpandableCardContentProps,
  "isMobile"
>;

const SHARED_STYLES = {
  width: "auto",
  padding: "12px",
  justifyContent: "space-between",
  gap: 2,
  position: "relative",
  backgroundColor: WHITE,
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
};

export default function ExpandableCardContent({
  content,
  button,
  regularHeight,
  collapsedHeight,
  isFocused,
  isMobile,
}: ExpandableCardContentProps) {
  return isMobile ? (
    <MobileExpandableCardContent
      content={content}
      button={button}
      isFocused={isFocused}
    />
  ) : (
    <DesktopExpandableCardContent
      content={content}
      button={button}
      regularHeight={regularHeight}
      collapsedHeight={collapsedHeight}
      isFocused={isFocused}
    />
  );
}

const MobileExpandableCardContent = ({
  content,
  button,
  isFocused,
}: MobileExpandableCardContentProps) => (
  <Stack sx={SHARED_STYLES}>
    <Stack>{content(isFocused)}</Stack>

    <Stack>{button(isFocused)}</Stack>
  </Stack>
);

const DesktopExpandableCardContent = ({
  content,
  button,
  regularHeight,
  collapsedHeight,
  isFocused,
}: DesktopExpandableCardContentProps) => (
  <Stack
    sx={{
      ...SHARED_STYLES,
      height: isFocused ? regularHeight : collapsedHeight,
      transition: theme.transitions.create(["height"], {
        duration: theme.transitions.duration.standard,
      }),
    }}
  >
    <Stack
      sx={{
        overflow: isFocused ? "auto" : "hidden",
      }}
    >
      {content(isFocused)}
    </Stack>

    <Stack>{button(isFocused)}</Stack>
  </Stack>
);
